/** Single source for public company / contact facts on the marketing site. */
export const COMPANY = {
  /** Trade / brand name */
  brand: "StageGrid Systems",
  /** Legal entity as registered */
  legalName: "StageGrid Systems SRL",
  /** Legal form (Moldovan company law) */
  legalForm: "Societate cu răspundere limitată (SRL)",
  /** Short country label for UI */
  country: "Republic of Moldova",
  /** ISO 3166-1 alpha-2 */
  countryCode: "MD",
  /**
   * Governing law / seat of the company.
   * Prefer the full English state name in legal prose.
   */
  jurisdiction: "the Republic of Moldova",
  email: "sgs@stagegridsystems.com",
  site: "https://stagegridsystems.com",
  /** Short brand line for hero / footer. */
  tagline: "Industrial digital infrastructure for live production.",
  /** One-sentence definition for hero, AI discovery, and crawlable HTML. */
  definition:
    "StageGrid Systems builds software and hardware for live production — rack planning, lighting control, timecoded show playback, and organization inventory.",
  /** Explicit brand collision note (DSPRO/Waves StageGrid stageboxes dominate web search). */
  disambiguation:
    "Independent company (StageGrid Systems SRL, Republic of Moldova). Not affiliated with DSPRO or Waves StageGrid audio stageboxes, or with portable staging hardware vendors.",
  /**
   * Moldovan personal-data supervisory authority (CNPDCP).
   * https://datepersonale.md
   */
  dataAuthority: {
    name: "National Center for Personal Data Protection (CNPDCP)",
    nameRo: "Centrul Național pentru Protecția Datelor cu Caracter Personal",
    url: "https://datepersonale.md"
  }
} as const;
